import React from 'react'
import "./A2Benefits.css"
import A2BenefitsHead from './A2BenefitsHead'
import A2BenefitsMain from './A2BenefitsMain'

const A2Benefits = () => {
  return (
    <div className='lvlBenefitsContainer'>
      <A2BenefitsHead/>
      <A2BenefitsMain/>
    </div>
  )
}

export default A2Benefits
